import React from 'react';
import { Section, Label, ContentRow, Brasil } from './styles';
import { Variacoes } from '@/components/ranking/organisms/AreaVariationBest';
import { makeVirgula } from '@/utils/factorys';

interface IProps {
  data: Variacoes
}
const performFerderalUnion = (ufs: string[]): string => ufs.join(', ');

export const VariationSectionBest: React.FC<IProps> = ({ data }) => {
  return (
    <>

      <Section>
        <Label> <p>MELHOR UF </p></Label>
        <ContentRow>
          <p>{performFerderalUnion(data?.melhor?.UF)}</p>
        </ContentRow>
        <ContentRow style={{border:"none"}}>
        {makeVirgula(data?.melhor?.valor)}
        </ContentRow>
      </Section>
      <Section>
        <Label> <p>MÉDIA BRASIL </p></Label>
        <ContentRow>
         <Brasil />
        </ContentRow>
        <ContentRow style={{border:"none"}}>
          {makeVirgula(data?.media_br)}
        </ContentRow>
      </Section>
      <Section>
        <Label> <p>PIOR UF</p> </Label>
        <ContentRow  >
          <p>{performFerderalUnion(data?.pior?.UF)}</p>
        </ContentRow>
        <ContentRow style={{border:"none"}}>
        {makeVirgula(data?.pior?.valor)}
        </ContentRow>
      </Section>
    </>
  );
};
